module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"title":"My gear","search":"Search name, category or manufacturer","add_items":"Add","add_single":"Add this item"},"de":{"title":"Meine Ausrüstung","search":"Namen, Kategorie oder Hersteller suchen","add_items":"Hinzufügen","add_single":"Diesen Gegenstand hinzufügen"}}')
  delete Component.options._Ctor
}
